<template>
  <div class="stat-menu-abc">
    <v-container fluid>
      <stat-top-filter
        :days-count="30"
        :filial-default="globalFilialId"
        @applyFilter="fetchData"
      >
        <template #additional-filter>
          <label class="stat-filter-col__label">выбрать <br> агрегаторы:</label>
          <enum-select-field
            v-model="aggregators"
            :all-selected.sync="allAggregatorsSelected"
            style="border-radius: 10px;"
            :loading="loading"
            label="Агрегаторы"
            select-all-label="Все агрегаторы"
            :enum-class="enumClass"
            background-color="#fff"
            height="40"
            max-width="480px"
            multiple
            hide-details
            flat
            solo
            chips
          />
          <abc-search-field v-model="search" />
        </template>
      </stat-top-filter>
      <loader v-if="loading" />
      <template v-else>
        <div class="stat-menu-abc-table">
          <v-data-table
            v-if="filteredStatisticData.length"
            fixed-header
            :headers="headers"
            :items="filteredStatisticData"
            :items-per-page="-1"
            class="statistic-datatable headers-nowrap orange-header"
            :footer-props="{disableItemsPerPage: true}"
            :options="tableOptions"
          >
            <template v-slot:item="{item, index}">
              <tr>
                <td class="text-center">
                  {{ index + 1 }}
                </td>
                <td>
                  {{ getMenuItemId(item) }}
                </td>
                <td><menu-item-label :item="item.menuItem" /></td>
                <td><menu-item-category :item="item.menuItem" /></td>
                <td>{{ getAggregatorName(item.basketSource) }}</td>
                <td class="text-center">
                  {{ Number(item.soldCount) ? item.averagePriceFormatted : '-' }}
                </td>
                <td class="text-center">
                  {{ item.soldCount }}
                </td>
                <td class="text-center">
                  {{ item.freeCount }}
                </td>
                <td class="text-center">
                  {{ item.costFormatted }}
                </td>
              </tr>
            </template>
          </v-data-table>
          <div v-else class="no-data-label">
            {{ search ? 'Ничего не найдено' : 'Нет записей за выбранный период' }}
          </div>
        </div>
      </template>
    </v-container>
  </div>
</template>

<script>
  import Loader from '@/components/loader/Loader'
  import StatTopFilter from '@/components/stat/StatTopFilter.vue'
  import { mapGetters } from 'vuex'
  import MenuItemLabel from '@/components/stat/menu/MenuItemLabel.vue'
  import MenuItemCategory from '@/components/stat/menu/MenuItemCategory.vue'
  import EnumSelectField from '@/components/ui/selects/EnumSelectField.vue'
  import AbcSearchField from '@/components/stat/menu/AbcSearchField.vue'
  import AggregatorType from '@/models/enums/AggregatorType'
  import menuApi from '@/api/statistics/menu'
  import { filterAbcItems } from '@/util/statistics/abc'

  export default {
    name: 'AbcAnalysis',
    components: {
      MenuItemCategory,
      MenuItemLabel,
      StatTopFilter,
      AbcSearchField,
      Loader,
      EnumSelectField,
    },
    data () {
      return {
        showDaysCount: 30,
        loading: false,
        statisticData: [],
        search: '',
        aggregators: [],
        allAggregatorsSelected: true,
        tableOptions: {
          sortBy: ['cost'],
          sortDesc: [true],
        },
        headers: [
          { text: '#', value: 'id', align: 'center' },
          { text: 'ID', value: 'menuItemId', align: 'left' },
          { text: 'Блюдо', value: 'menuItemName', align: 'left', sort: (a, b) => a.toLowerCase().localeCompare(b.toLowerCase()) },
          { text: 'Категория', value: 'category', align: 'left' },
          { text: 'Агрегатор', value: 'basketSource', align: 'left' },
          { text: 'Средняя цена блюда', value: 'averagePrice', align: 'center' },
          { text: 'Продано, шт.', value: 'soldCount', align: 'center' },
          { text: 'Бесплатно, шт.', value: 'freeCount', align: 'center' },
          { text: 'Выручка', value: 'cost', align: 'center' },
        ],
      }
    },
    computed: {
      ...mapGetters({
        globalFilialId: 'branches/getGlobalFilialId',
      }),
      enumClass () {
        return AggregatorType
      },
      filteredStatisticData () {
        return filterAbcItems(this.statisticData, this.search)
      },
    },
    methods: {
      getAggregatorName (value) {
        return AggregatorType.getName(value)
      },
      getMenuItemId (item) {
        return item?.menuItem?.id
      },
      async fetchData (filter) {
        this.loading = true
        this.statisticData = []

        const payload = {
          from: filter.from,
          to: filter.to,
          filialId: filter.filialId,
          filialPreset: filter.filialPreset,
          aggregators: this.aggregators,
          allAggregators: this.allAggregatorsSelected,
        }

        try {
          const response = await menuApi.fetchAggregatorsABCAnalysis(payload)
          this.statisticData = response.items
        } catch (err) {
          this.showErrorFromResponse(err)
        }

        this.loading = false
      },
    },
  }
</script>

<style lang="less" scoped>
@import "src/assets/styles/statistic.less";
</style>
